import { render, staticRenderFns } from "./taskset.vue?vue&type=template&id=3acefb24&scoped=true&"
import script from "./taskset.vue?vue&type=script&lang=js&"
export * from "./taskset.vue?vue&type=script&lang=js&"
import style0 from "./taskset.vue?vue&type=style&index=0&id=3acefb24&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acefb24",
  null
  
)

export default component.exports